import React from "react"

const About = () => {
    return(
        <div className="container">
            <h4 className="center">How to use</h4>
            <ul>
            <h5>Video call</h5>
                <l1>Click on copy your id</l1>
                <li>Share this id to the person whom with you want to connect</li>
                <li>Ask him to paste this in id to call column</li>
                <li>Click on call button</li>
                <li>you will receive notification like xyz is calling , accept it </li>
                <li>To hangup press on hangup button</li>
                <li>Features like video pause mute and share screen are also availaible</li>
            </ul>
            <ul>
                <h5>Message</h5>
                <li>write your name</li>
                <li>Simply send message</li>
            </ul>
        </div>
    )
}
export default About